export default class Spinner {
  get spinnerHTML() {
    return this._spinnerHTML;
  }

  static clearAndAppend($elem, html) {
    $elem.empty().append(html);
  }

  static show() {
    const $threats = $('#threats');

    if (!$threats.find('#spinner').length) {
      Spinner.clearAndAppend($threats, '<div id="spinner"></div>');
    }
  }
}
